export enum ConfigName {
  CANDIDATE_MODAL_ENABLED = 'CANDIDATE_MODAL_ENABLED',
  REVAMPED_FILTERS_ENABLED = 'REVAMPED_FILTERS_ENABLED',
  MARKETPLACE_V2_ENABLED = 'MARKETPLACE_V2_ENABLED',
  MARKETPLACE_PROFILE_REDESIGN = 'MARKETPLACE_PROFILE_REDESIGN',
  VENDOR_MANAGEMENT = 'VENDOR_MANAGEMENT',
  SUBSCRIPTION_TIER_RESTRICTION = 'SUBSCRIPTION_TIER_RESTRICTION',
  TALENTHUB_JOBS_V2 = 'TALENTHUB_JOBS_V2',
  VENDOR_PROFILE_ENABLED = 'VENDOR_PROFILE_ENABLED',
  PRESCREEN = 'PRESCREEN',
}
